import { Icon } from "@iconify/react";
import { useRef, useState } from "react";
import personFill from "@iconify/icons-eva/person-fill";
import settings2Fill from "@iconify/icons-eva/settings-2-fill";
import { useNavigate } from "react-router-dom";
import ChangePassword from "./ChangePassword";
import { alpha } from "@mui/material/styles";
import {
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
  Avatar,
  IconButton,
} from "@mui/material";
import MenuPopover from "../../components/MenuPopover";
import { s3baseUrl } from "src/config/config";
import { get_root_value } from "src/utils/domUtils";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";

const MENU_OPTIONS = [
  {
    label: "Edit Profile",
    icon: personFill,
    linkTo: "/edit-profile",
  },
  {
    label: "Settings",
    icon: settings2Fill,
    linkTo: "/payment-request",
  },
];

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const navigate = useNavigate();

  const [openPasswordModal, setopenPasswordModal] = useState(false);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleProfile = (value) => {
    navigate(value);
    handleClose();
  };

  const { userInfo } = useContentSetting();

  const handleLogout = async () => {
    localStorage.removeItem("token");
    navigate("/login");
  };
  const handleChange = () => {
    handleClose();
    navigate(`/dashboard`);
  };
  return (
    <>
      <ChangePassword
        openPasswordModal={openPasswordModal}
        setopenPasswordModal={setopenPasswordModal}
      />
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
            color: get_root_value("--portal-theme-primary"),
          }),
        }}
      >
        {userInfo !== null &&
        userInfo !== undefined &&
        userInfo !== "undefined" ? (
          <Avatar
            src={userInfo ? s3baseUrl + userInfo?.profile_image : "R"}
            alt={userInfo?.first_name + " " + userInfo?.last_name}
          ></Avatar>
        ) : (
          ""
        )}
      </IconButton>

      <MenuPopover
        Popover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        {userInfo !== null &&
        userInfo !== undefined &&
        userInfo !== "undefined" ? (
          <Box sx={{ my: 1.5, px: 2.5 }} onClick={handleChange} color="inherit">
            <Typography variant="subtitle1" noWrap>
              {userInfo?.first_name + " " + userInfo?.last_name}
            </Typography>
            <Typography variant="body2" noWrap>
              {userInfo?.email}
            </Typography>
          </Box>
        ) : (
          ""
        )}
        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => handleProfile(option.linkTo)}
            sx={{ typography: "body2", py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24,
                color: "#ea7423",
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={() => handleLogout()}
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
